import Api from './api';

const transferenciasEstadoService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/transferenciasestado/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/transferenciasestado/buscar?${params}`)
        return response
    },
    catTrans: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/transferenciasestado/categorias',
            params: params
        })
        return response
    },
}

export default transferenciasEstadoService;